import React from 'react';
import { Tag } from '@televet/kibble-ui/build/components/Tag';
import { CardFunding } from 'shared/types/graphql';

interface FundingTypeTagProps {
  fundingType: CardFunding | undefined;
  isCardSelected?: boolean;
}

const FundingTypeTag = ({ fundingType, isCardSelected }: FundingTypeTagProps): JSX.Element | null => {
  // if fundingType is undefined return null
  if (!fundingType || !isCardSelected) return null;

  return fundingType === CardFunding.Credit ? (
    <Tag ml={5} label="Credit Card" bg="background.subtle" />
  ) : (
    <Tag ml={5} label="Debit Card" bg="background.success" />
  );
};

export default FundingTypeTag;
